var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 5.25H2.625C2.14175 5.25 1.75 5.64175 1.75 6.125V24.5C1.75 24.9832 2.14175 25.375 2.625 25.375H4.375C4.85825 25.375 5.25 24.9832 5.25 24.5V6.125C5.25 5.64175 4.85825 5.25 4.375 5.25Z",
    stroke: "#09AA6E",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 12.25H13.125M6.125 21.875H13.125",
    stroke: "#09AA6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 8.75H7C6.51675 8.75 6.125 9.14175 6.125 9.625V24.5C6.125 24.9832 6.51675 25.375 7 25.375H12.25C12.7332 25.375 13.125 24.9832 13.125 24.5V9.625C13.125 9.14175 12.7332 8.75 12.25 8.75Z",
    stroke: "#09AA6E",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 2.625H14.875C14.3918 2.625 14 3.01675 14 3.5V24.5C14 24.9832 14.3918 25.375 14.875 25.375H18.375C18.8582 25.375 19.25 24.9832 19.25 24.5V3.5C19.25 3.01675 18.8582 2.625 18.375 2.625Z",
    stroke: "#09AA6E",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1032 5.2559L20.8938 5.48832C20.2857 5.55231 19.8449 6.12106 19.9132 6.7516L21.8229 24.3386C21.8918 24.9691 22.4447 25.4323 23.0529 25.3689L25.2622 25.1364C25.8703 25.0725 26.3111 24.5037 26.2428 23.8732L24.3358 6.28895C24.2642 5.65567 23.7113 5.19192 23.1032 5.2559Z",
    stroke: "#09AA6E",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.aef592e22aaca6c4b7c0ea2a2e6cf54e.svg";
export { ForwardRef as ReactComponent };